import { HotelCard } from "@website/accommodation-ui/hotel-card-new";
import { HotelCardSuggestionCarouselPropertiesTypes } from "@website/accommodation-ui/hotel-cities-main-content/hotel-suggestion-carousel/hotel-suggestion-carrousel.types";
import { MaterialIcon } from "@website/icons/material";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import { deepCompare } from "@website/utils/deep-compare";
import set from "lodash-es/set";
import { memo, useCallback, useState } from "react";

const Component = (properties: HotelCardSuggestionCarouselPropertiesTypes) => {
  const { hotelsSuggested } = properties;

  const [isOpen, setIsOpen] = useState(hotelsSuggested?.length > 0);
  const handleClick = useCallback(() => setIsOpen(false), []);
  return (
    <div
      className="bg-transparent-secondary lg:border-outline-thin mx-[-24px] h-[180px] min-w-[200px] pb-6 pl-6 pt-[18px] md:min-w-[360px] lg:mx-0 lg:h-[180px] lg:rounded-[12px] lg:border xl:max-w-[864px] rtl:pl-0 rtl:pr-6"
      hidden={!isOpen}
    >
      <div className="text-subtitle-2 end-6 flex h-[34px] flex-row items-center justify-between pb-3 pe-6 lg:h-[28px]">
        {properties?.loading ? (
          <Skeleton height={24} />
        ) : (
          <>
            <div className="text-secondary">هتل های پیشنهادی</div>
            <MaterialIcon
              className="text-secondary cursor-pointer"
              name="clear"
              onClick={handleClick}
            />
          </>
        )}
      </div>
      {properties?.loading ? (
        <Skeleton height={112} />
      ) : (
        <CarouselV2
          itemClass="w-[277.33331px] px-2"
          key="suggested_hotels_carousel"
          keyCarousel="suggested_cities_carousel"
          list={
            hotelsSuggested
              ?.slice(0, 6)
              ?.map((hotelsSuggestionProperties, index) => (
                <HotelCard
                  index={index}
                  hotelInfo={set(
                    hotelsSuggestionProperties,
                    "hotelDetail.hotelPageUrl.query.utm_source",
                    "suggested_hotels"
                  )}
                  key={hotelsSuggestionProperties.id}
                  size="xSmall"
                  isSuggestedCard
                  shouldRedirectUsingJs
                />
              )) || []
          }
          mode="free"
          options={{ slides: { perView: "auto" } }}
        />
      )}
    </div>
  );
};
export const HotelSuggestionCarousel = memo(Component, deepCompare);
